export const REDIRECT_URI_PARAM = 'redirectUri';
export const REDIRECT_EXAMPLE_URI = 'https://lms.com/return?course=5&token=abc';

const REDIRECT_LOOKALIKE = /redirect|(return|callback|back)[-_]?(url|uri|link|to)/i;

export type RedirectPresetError = 'redirectEncoded' | 'redirectInvalid';

export function isRedirectParam(key: string): boolean {
    return key === REDIRECT_URI_PARAM;
}

export function looksLikeRedirectParam(key: string): boolean {
    return !isRedirectParam(key) && REDIRECT_LOOKALIKE.test(key);
}

export function getRedirectPresetError(value: string): RedirectPresetError | null {
    if (!value) return null;
    if (/^https?%3A/i.test(value)) return 'redirectEncoded';
    if (!/^https?:\/\//i.test(value)) return 'redirectInvalid';

    try {
        const {protocol} = new URL(value);
        return protocol === 'http:' || protocol === 'https:' ? null : 'redirectInvalid';
    } catch {
        return 'redirectInvalid';
    }
}

export function hasInvalidRedirectPreset(params: {key: string; value: string}[]): boolean {
    return params.some((param) => isRedirectParam(param.key) && !!getRedirectPresetError(param.value));
}
